<template>
  <div>
    <documents-crud-list
      title="Organisation institutionnelle et fonctions"
      category="Organisation institutionnelle et fonctions"
    />
  </div>
</template>

<script>
import DocumentsCrudList from './UIComponents/DocumentsCrudList.vue';

export default {
  components: {
    DocumentsCrudList,
  },
};
</script>
